import React, { useEffect, useState } from 'react';
import { Odd } from '../../../../models/Odd_response_model.tsx';
import { BetDetails } from '../../../../models/MyBetModel.tsx';
import { useBetContext } from '../../../../context/BetContext.tsx';
import { MdKeyboardArrowDown } from "react-icons/md";
import { GrFormClose } from "react-icons/gr";
import { calcProfit, calcStake, formatBetScheduled, formatSpecialtyMarketLabel, getName, getBetSpecialtyMarketLabel, getBetSelectionLabel, getBetTeamPickName, getPeriodTeamSuffix } from '../../../../helpers/functions.tsx';
import BetLogo from '../BetLogo.tsx';
import { BetSlipTrashButton, SlipOddStepper, SlipPickMarket, SlipPickStakes } from '../BetSlipChrome.tsx';

// interface ITeamOdd {
//     bet: BetDetails & { oddsImproved?: boolean };
// }
interface ITeamOdd {
    bet: BetDetails;
    oddsImproved?: boolean | null;
}

const TeamOdd = (props: ITeamOdd) => {

    const { bet } = props;
    const { updateBet, deleteBet } = useBetContext();
    const [odd, setOdd] = useState(bet.odd);
    const [stake, setStake] = useState(bet.bet);
    const [profit, setProfit] = useState(bet.reward ?? 0)
    const [showLeagueDetails, setShowLeagueDetails] = useState(false);

    useEffect(() => {
        setStake(bet.bet);
        setProfit(bet.reward ?? 0);
        setOdd(bet.odd);
    }, [bet.bet, bet.reward, bet.odd]);

    const updateStake = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const price = odd?.price ?? 0;

        if (value === "") {
            setStake(0);
            setProfit(0);
            updateBet({ ...bet, bet: 0, reward: 0, odd });
            return;
        }

        const newStake = parseFloat(value);
        if (isNaN(newStake) || newStake < 0) return;

        const roundedStake = Math.round(newStake);

        let newProfit = 0;

        if (price > 0) {
            newProfit = Math.round(roundedStake * (price / 100));
        } else if (price < 0) {
            newProfit = Math.round(roundedStake * (100 / Math.abs(price)));
        }

        setStake(roundedStake);
        setProfit(newProfit);

        updateBet({ ...bet, bet: roundedStake, reward: newProfit, odd });
    };

    const updateProfit = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const price = odd?.price ?? 0;

        if (value === "") {
            setProfit(0);
            setStake(0);
            updateBet({ ...bet, bet: 0, reward: 0, odd });
            return;
        }

        const profitValue = parseFloat(value);
        if (isNaN(profitValue) || profitValue < 0) return;

        const roundedProfit = Math.round(profitValue);

        let newStake = 0;

        if (price > 0) {
            newStake = Math.round(roundedProfit / (price / 100));
        } else if (price < 0) {
            newStake = Math.round(roundedProfit / (100 / Math.abs(price)));
        }

        setStake(newStake);
        setProfit(roundedProfit);

        updateBet({ ...bet, bet: newStake, reward: roundedProfit, odd });
    };

    const applyOdd = (newOdd: Odd) => {
        setOdd(newOdd);

        const price = newOdd.price;

        const safeStake: number = stake ?? 0;
        const safeProfit: number = profit ?? 0;
        let newStake = safeStake;
        let newProfit = safeProfit;

        if (price > 0) {
            newStake = safeStake;
            newProfit = Math.round(calcProfit(newStake, price));
        } else {
            newProfit = safeProfit;
            newStake = Math.round(calcStake(newProfit, price));
        }

        setStake(newStake);
        setProfit(newProfit);

        updateBet({
            ...bet,
            bet: newStake,
            reward: newProfit,
            odd: newOdd,
            betName: newOdd.name,
            id_selection: bet.id_selection,
        });
    };

    const toggleLeagueDetails = () => {
        setShowLeagueDetails(prevState => !prevState);
    };
    
    const oddsList: Odd[] = bet?.odds && bet.odds.length > 0
        ? bet.odds : bet?.odd ? [bet.odd] : [];
    const specialtyMarketLabel = getBetSpecialtyMarketLabel(bet);


    return (
        <>
            <div className="slip-pick">
                <div className='league' onClick={toggleLeagueDetails}>
                    <div className='centerModal'>
                        <span className='bet-text-league'>{bet.league}</span>
                    </div>
                    <div className='centerModal'>
                        {showLeagueDetails ? <GrFormClose className='icon-modal' /> : <MdKeyboardArrowDown className='icon-modal' />}
                    </div>
                </div>

                <div>
                    <div className={`game-team ${showLeagueDetails ? 'no-border' : ''}`}>
                        <div className='centerModal slip-pick__team'>
                            <BetLogo bet={bet} alt="team logo" />
                            <div className="slip-pick__meta">
                                <span className={`text-title-bet ${bet.oddsImproved === null || bet.oddsImproved === undefined ? "" : bet.oddsImproved ? "odds-up" : "odds-down"}`}>
                                    <span className="title-bet-name">
                                        {bet.odd?.team_id ? (
                                            getBetTeamPickName(bet)
                                        ) : bet.odd?.player_id ? (
                                            <>
                                                {bet.betName}
                                                {!specialtyMarketLabel && (
                                                    <span className='title-bet-name-pending'>{bet.odd.market}</span>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {[bet.teamId, bet.opposingTeam]
                                                    .filter(Boolean)
                                                    .map((name) => getName(name, bet.league))
                                                    .join(" vs ")
                                                }{getPeriodTeamSuffix(bet.marketName || bet.odd?.market, bet.league)}
                                            </>
                                        )}
                                        {bet?.gameType?.toLowerCase().includes("live") && (
                                            <span className="live-bet-label">
                                                &nbsp;(Live)
                                                <span className="live-text-dot" aria-hidden="true" />
                                            </span>
                                        )}
                                    </span>
                                </span>
                                {oddsList.length > 0 && (
                                    <SlipPickMarket label={specialtyMarketLabel || formatSpecialtyMarketLabel(bet.marketName)} />
                                )}
                            </div>
                        </div>
                        <div className='centerModal slip-pick__odds-wrap'>
                            <span className='price show-modal'>Buy Points</span>
                            {oddsList.length > 0 && (
                                <SlipOddStepper
                                    odds={oddsList}
                                    value={odd?.id}
                                    marketName={bet.marketName}
                                    onSelect={applyOdd}
                                />
                            )}
                            <BetSlipTrashButton onClick={() => deleteBet(bet)} />
                        </div>

                    </div>
                    {specialtyMarketLabel && (
                        <div className={`bet-specialty-market-label${bet.betType === "Contest" || bet?.gameType?.toLowerCase().includes("live") ? ' is-live' : ''}`}>{specialtyMarketLabel}</div>
                    )}
                    {showLeagueDetails && (
                        <div className="league-details">
                            <span className='details-bet'><span className='details-bet-title'>Scheduled : </span>{formatBetScheduled(bet.gameDate)}</span>
                            <span className='details-bet'><span className='details-bet-title'>Selection : </span>{getBetSelectionLabel(bet)}</span>
                        </div>
                    )}
                </div>

                <SlipPickStakes
                    stake={stake || ''}
                    profit={profit || ''}
                    onStakeChange={updateStake}
                    onProfitChange={updateProfit}
                    onDelete={() => deleteBet(bet)}
                />

            </div>
        </>
    );
};

export default TeamOdd